import {
    STEP_PHONE,
    STEP_ADDRESS,
    STEP_DATETIME,
    STEP_PAYMENT,
} from '../stepByStepCheckoutConst';

export const readyToEatDialogLocales = {
    ru: {
        strongText: 'Будет новое меню',
        regularText: 'Часть блюд недоступна по новому адресу - мы удалим их из корзины. Продолжить оформление заказа без них?',
        confirmText: 'Да',
        rejectText: 'Нет',
    },
    en: {
        strongText: 'There will be a new menu',
        regularText: 'Some dishes are not available at the new address - we will remove them from the cart. Continue checkout without them?',
        confirmText: 'Yes',
        rejectText: 'No',
    },
};

export const locales = {
    ru: {
        headerTitle: 'Оформление заказа',
        [STEP_PHONE]: 'Ваш телефон',
        [STEP_ADDRESS]: 'Адрес доставки',
        [STEP_DATETIME]: 'Дата и время',
        [STEP_PAYMENT]: 'Способ оплаты',
    },
    en: {
        headerTitle: 'Checkout',
        [STEP_PHONE]: 'Your phone number',
        [STEP_ADDRESS]: 'Delivery address',
        [STEP_DATETIME]: 'Date and time',
        [STEP_PAYMENT]: 'Payment method',
    },
};
